import React from "react";

type ArrowProps = {
  color?: string;
  direction?: "left" | "right"; // New prop to handle direction
};

const Arrow: React.FC<ArrowProps> = ({
  color = "#C4C6CD",
  direction = "left",
}) => {
  const arrowPath =
    direction === "left"
      ? "M15.32 2.82L12.5 0L0.5 12L12.5 24L15.32 21.18L6.16 12L15.32 2.82Z"
      : "M0.68 2.82L3.5 0L15.5 12L3.5 24L0.68 21.18L9.84 12L0.68 2.82Z"; // Path for right arrow

  return (
    <svg
      width="16"
      height="24"
      viewBox="0 0 16 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d={arrowPath} fill={color} />
    </svg>
  );
};

export default Arrow;
